import { Box, Container, Grid, Typography } from '@mui/material'
const Footer = () => {
  return (
         <Box
        sx={{
          background: '#1a1b2f',
          display: 'flex',
          alignItems: 'center',
          color: '#222',
          p: '15px',
          m: 0,
        }}
      >
        <Container maxWidth="xl">
            <Grid sx={{ justifyContent: 'center' }} container spacing={{ xs: 2, md: 3 }} >
            <Grid sx={{ textAlign: { xs: 'center', md: 'left' },color:'#fff' }} item  xs= {12} sm= {6} md={6}>
                <Typography variant='p'>
                    © 2023 MiiRA Corp.
                </Typography>
            </Grid>

            <Grid sx={{ textAlign: { xs: 'center', md: 'left' } }} item  xs= {12} sm= {6} md={6}>
                  {/* <ul className='socialmedia'>
                      <li>
                        <a className='links3'><FacebookIcon></FacebookIcon></a>
                      </li>
                      <li>
                        <a className='links3'><InstagramIcon></InstagramIcon></a>
                      </li>
                      <li>
                        <a className='links3'><XIcon></XIcon></a>
                      </li>
                      <li>
                        <a className='links3'><GoogleIcon></GoogleIcon></a>
                      </li>
                    
                    </ul> */}
            </Grid>
          </Grid>
        </Container>
      </Box>
 

  )
}

export default Footer